<template>
  <div class="contrato-container">
    <div class="header-section">
      <div class="logo-area logo-left">
        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid logo-img" />
      </div>
      <div class="title-center">
        PLANILHA DE MEDIÇÃO
      </div>
      <div class="logo-area logo-right">
        <img v-if="dados.logoFornecedorUrl" :src="dados.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid logo-img" />
        <div v-else class="box-placeholder">
          Logomarca da empresa<br>(consórcio) contratada
        </div>
      </div>
    </div>

    <div class="data-table">
      <div class="table-row">
        <div class="cell left-col">
          <span class="label">CONTRATO:</span>
          <span class="value">{{ dados.numeroContrato }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">MEDIÇÃO:</span>
          <span class="value">{{ dados.medicao }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell left-col">
          <span class="label">CONTRATADA:</span>
          <span class="value">{{ dados.contratada }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">PERÍODO:</span>
          <span class="value">{{ dados.periodo }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell left-col">
          <span class="label">ORDEM DE SERVIÇO:</span>
          <span class="value">{{ dados.ordemServico }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">VALOR DA MEDIÇÃO:</span>
          <span class="value">{{ dados.valorMedicao | currency }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell left-col">
          <span class="label">PRAZO DE VIGÊNCIA:</span>
          <span class="value">{{ dados.prazoVigencia }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">PROCESSO LICITATÓRIO:</span>
          <span class="value">{{ dados.processoLicitatorio }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell left-col">
          <span class="label">BDI SERVIÇO:</span>
          <span class="value">{{ dados.bdiServico | percent }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">BDI MATERIAL:</span>
          <span class="value">{{ dados.bdiMaterial | percent }}</span>
        </div>
      </div>

      <div class="table-row merged-row">
        <div class="cell left-col full-center">
          <span class="label">OBJETO:</span>
          <span class="value object-text">{{ dados.objeto }}</span>
        </div>

        <div class="right-stack">
          <div class="cell stack-item border-bottom">
            <span class="label">VALOR DO CONTRATO:</span>
            <span class="value">{{ dados.valorContrato | currency }}</span>
          </div>

          <div class="cell stack-item border-bottom">
            <span class="label">TOTAL MEDIDO:</span>
            <span class="value">{{ dados.totalMedido | currency }}</span>
          </div>

          <div class="cell stack-item">
            <span class="label">SALDO CONTRATUAL:</span>
            <span class="value">{{ dados.saldoContratual | currency }}</span>
          </div>
        </div>
      </div>

    </div>

    <div v-if="$slots.default" class="content-slot mt-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            required: true
        },
        boletimMedicao: {
            type: Object,
            required: true
        },
        valorTotalTodosBoletins: {
            type: Number,
            required: false
        },
        fornecedorLogoUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            logoSuape: '/img/logo.png'
        }
    },
    methods: {
        formatarDataPeriodo(data) {
            if (!data) return ''
            const dataFormatada = this.$moment(data)
            if (!dataFormatada.isValid() || dataFormatada.year() <= 1) return ''
            return dataFormatada.format('DD/MM/YYYY')
        },
        obterPeriodoBoletim() {
            const inicio = this.formatarDataPeriodo(this.boletimMedicao.dataInicio)
            const fim = this.formatarDataPeriodo(this.boletimMedicao.dataFim)

            if (inicio && fim) return `${inicio} - ${fim}`
            if (inicio) return inicio
            if (fim) return fim

            return this.boletimMedicao.competencia
                ? `${this.$moment(this.boletimMedicao.competencia).startOf('month').format('DD/MM/YYYY')} - ${this.$moment(this.boletimMedicao.competencia).endOf('month').format('DD/MM/YYYY')}`
                : ''
        },
        obterPrazoVigencia() {
            const inicio = this.formatarDataPeriodo(this.contrato.inicioVigencia)
            const fim = this.formatarDataPeriodo(this.contrato.fimVigencia)
            if (inicio && fim) return `${inicio} a ${fim}`
            if (inicio) return inicio
            if (fim) return fim
            return '-'
        }
    },
    computed: {
        valorTotalBoletinsComputado() {
            if (this.valorTotalTodosBoletins !== undefined && this.valorTotalTodosBoletins !== null) {
                return this.valorTotalTodosBoletins
            }
            return this.boletimMedicao.total || 0
        },
        dados() {
            return {
                numeroContrato: this.contrato.codContrato,
                contratada: this.contrato.fornecedor ? (`${this.contrato.fornecedor.cnpj} - ${this.contrato.fornecedor.nome}`) : '',
                ordemServico: '-',
                objeto: this.contrato.objeto,
                medicao: this.boletimMedicao.numero,
                periodo: this.obterPeriodoBoletim(),
                valorContrato: this.contrato.valorTotal || 0,
                valorMedicao: this.boletimMedicao.total || 0,
                totalMedido: this.valorTotalBoletinsComputado || 0,
                saldoContratual: (this.contrato.valorTotal || 0) - (this.valorTotalBoletinsComputado || 0),
                logoFornecedorUrl: this.fornecedorLogoUrl,
                prazoVigencia: this.obterPrazoVigencia(),
                processoLicitatorio: this.contrato.numeroLicitacao || '-',
                bdiServico: this.contrato.propostaPreco ? this.contrato.propostaPreco.bdiGeral : null,
                bdiMaterial: this.contrato.propostaPreco ? this.contrato.propostaPreco.bdiDiferenciado : null
            }
        }
    },
    filters: {
        currency(value) {
            if (value === null || value === undefined) return 'R$ 0,00'
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        percent(value) {
            if (value === null || value === undefined || value === '') return '-'
            const num = Number(value)
            if (!isFinite(num)) return '-'
            return `${num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
        }
    }
}
</script>

<style scoped>
.contrato-container {
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  width: 100%;
  background: #fff;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 5px;
  min-height: 80px;
}

.logo-area { width: 20%; display: flex; align-items: center; }
.logo-left { justify-content: flex-start; }
.logo-right { justify-content: flex-end; }
.logo-img { max-width: 100%; max-height: 100px; object-fit: contain; }
.title-center { flex-grow: 1; text-align: center; font-weight: 600; font-size: 1.2rem; text-transform: uppercase; }
.box-placeholder { border: 1px solid #000; padding: 5px; font-weight: 500; text-align: center; font-size: 0.8rem; width: 100%; }

.data-table {
  border: 1px solid #000;
  display: flex;
  flex-direction: column;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #000;
}

.table-row:last-child {
  border-bottom: none;
}

.cell {
  padding: 2px 5px;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
}

.left-col {
  width: 60%;
  border-right: 1px solid #000;
}

.right-col {
  width: 40%;
}

.full-center {
  align-items: center;
  height: auto;
}

.right-stack {
  width: 40%;
  display: flex;
  flex-direction: column;
}

.stack-item {
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding: 2px 5px;
  min-height: 25px;
}

.border-bottom {
  border-bottom: 1px solid #000;
}

.label {
  font-weight: 600;
  text-transform: uppercase;
  margin-right: 5px;
  white-space: nowrap;
}

.value {
  font-weight: 400;
  flex-grow: 1;
}

.object-text {
  white-space: normal;
  line-height: 1.2;
}
</style>
